import { Component, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Platform, MenuController, Nav, Events, Toast, IonicApp } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { MenuService } from '../services/menu-service';
import { AppSettings } from '../services/app-settings';
import { MobileAppService } from '../services/mobile-app';

import { ComplaintTabsPage } from '../pages/complaint-tabs/complaint-tabs';
import { DashboardPage } from '../pages/dashboard/dashboard';
import { VisitorTabsPage } from '../pages/visitor-tabs/visitor-tabs';
import { HomePage } from '../pages/home/home';
import { NoticesPage } from '../pages/notices/notices';
import { ProfilePage } from '../pages/profile/profile';
import { BillingPaymentsPage } from '../pages/billing-payments/billing-payments';
import { MeterPage } from '../pages/meter/meter';
import { MySocietyPage } from '../pages/my-society/my-society';
import { FeedbackPage } from '../pages/feedback/feedback';
import { AboutUsPage } from '../pages/about-us/about-us';
import { MyStaffTabsPage } from '../pages/my-staff-tabs/my-staff-tabs';
import { LoginProvider } from '../providers/login/login';
import { SettingsPage } from '../pages/settings/settings';
import { ToastProvider } from '../providers/toast/toast';
import { MembersPage } from '../pages/members/members';
import { SurveyPage } from '../pages/survey/survey';
import { NetworkServices } from '../services/network-services';
import { environment } from '../environments/environment';
import { SocialSharing } from '@ionic-native/social-sharing';
import { FacilityPage } from '../pages/facility/facility';
import { HowItWorksPage } from '../pages/how-it-works/how-it-works';
import { MarketPlacePage } from '../pages/market-place/market-place';
import { SingleMarketPlacePage } from '../pages/single-market-place/single-market-place';
import { MarketplacecategoryPage } from '../pages/marketplacecategory/marketplacecategory';
import { ExportMeterPage } from '../pages/export-meter/export-meter';
import { GeneratePassPage } from '../pages/generate-pass/generate-pass';
import { ReferralPage } from '../pages/referral/referral';
import {	PermissionCheckPipe} from '../pipes/permission-check/permission-check';
import { StatusFilterPipe } from '../pipes/status/status';
import { SanitizePipe } from '../pipes/sanitize/sanitize';
import { EventsPage } from '../pages/Event/event';

@Component({
  templateUrl: 'app.html',
  providers: [MenuService]
})

export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage = "HomePage";
  pages: any;
  params: any;
  leftMenuTitle: string;
  public counter=0;
  permissions: any;
  isOnline = true;
  net: any;
  errorLogo:any;
  selRegistrationLogin : any;

  constructor(public platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public menu: MenuController,
    private perPipe: PermissionCheckPipe,
    private stpipe:StatusFilterPipe,
    private sanitize:SanitizePipe,
    private menuService: MenuService,
    private storage: Storage,
    private loginProvider: LoginProvider,
    public events: Events,
    private appService: MobileAppService,
    private toast: ToastProvider,
    private ionicApp: IonicApp,
    private networkServices: NetworkServices,
    private ref: ChangeDetectorRef,
    private socialSharing: SocialSharing,
    private translate: TranslateService) {
      
      this.selRegistrationLogin = localStorage.getItem('signup_login')

      if(this.selRegistrationLogin){
     
      this.params= {
        background : "",
        image : "/assets/images/logo/ism.png"
      } 
       
      }


      console.log("translate component loading time")
      this.errorLogo = 'assets/images/logo/ism'+environment.icon+'.png';
      let url = location.toString();
      console.log("ULR==1=", url, new Date());
      if(url.indexOf('?') > 1){
        let params = url.split("?");
        if(params.length > 1){
          params = params[1].split("&");
          let result = {}
          params.forEach(param => {
            let keyVal = param.split("=");
            let keys = ["api_token","id", "tenant", "app_name"];
            if(keyVal.length > 1 && keys.indexOf(keyVal[0]) >= 0){
              result[keyVal[0]] = keyVal[1];
            }         
          })
          if(Object.keys(result).length > 0){
            this.loginProvider.updateUserRegisterApp(result);
          }
        }
      }
    this.initializeApp();


    //this.statusBar.backgroundColorByName("black");

    this.pages = menuService.pages;

    events.subscribe('user:created', (val) => {

      this.permissions = val.permissions;
      
      if(!val.image_src){
        val.image_src = 'assets/images/visitor/defaultpic.png';
      }
      this.params =  {
        "background": val.image_src,
        "image":  this.loginProvider.getSocietyLogo(),
        "homeAway": val.home_away,
        "society": val.society_name
      };
      // console.log(this.params);
    });

    this.networkServices.initializeNetworkEvents();
    this.events.subscribe('network:offline', () => {
      this.isOnline = false;
      this.net = {
        status: "offline",
        title: "You're currently offline!"
      };
      this.ref.detectChanges();
    });
    this.events.subscribe('network:online', () => {
      this.net = {
        status: "online",
        title: "Back Online!"
      };
      this.ref.detectChanges();
      setTimeout(() => {
        this.isOnline = true;
        this.ref.detectChanges();
      }, 1000);
    });
      platform.ready().then(() => {      
        translate.addLangs(["en", "zh", "vi", "km"]);  
        // translate.setDefaultLang('en');
        let lang = localStorage.getItem('lang');
        console.log(lang)
        if(!lang){
          lang = translate.getBrowserLang();
        }
        if(environment.debug) console.log("Browser locale is: ", lang);               
        translate.use(lang.match(/en|zh|vi|km|/) ? lang : 'en');
    });
    
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.splashScreen.hide();
      console.log(".....app initialized ")
      // this.backgroundMode.enable();
      // this.backgroundMode.on('activate').subscribe(() => {
      //   console.log('Background Mode activated');
      //   this.backgroundMode.disableWebViewOptimizations();
      // });
      // setInterval(() => {
      //   console.log(`App is running in the background: ${new Date().toLocaleTimeString()}`);
      // }, 60000);
      this.platform.pause.subscribe(() => {
        if(environment.debug) console.log("this.platform.pause");       
      });
      this.platform.resume.subscribe(() => {
        // let url = localStorage.getItem('open_url');        
        // if(environment.debug) console.log("this.platform.resume, URL =>", localStorage.getItem('open_url') );
        // if(url && url.indexOf('//') > 1){
        //   let params = url.split("//");
        //   if(params.length > 1){
        //     switch(params[1]){
        //       case 'vms/pass/guest':
        //         this.nav.push(GeneratePassPage, {
        //           purpose: {
        //             name: 'guest',
        //             icon: 'people'
        //           },
        //         });
        //         break;
        //     }
        //   }
        // }
      });
      //this.statusBar.styleDefault();
      if(environment.runAs == environment.constant.APP){
        this.appService.initOneSignal();
        this.appService.registerApp()
      }
      this.appService.checkAppUpdate();
      this.platform.registerBackButtonAction(() => {
        let activePortal = this.ionicApp._loadingPortal.getActive() ||
        this.ionicApp._modalPortal.getActive() ||
        this.ionicApp._overlayPortal.getActive();

        if (activePortal) {
          activePortal.dismiss();
        }else if(this.nav.canGoBack()){
          this.nav.pop();
        }else{
          if (this.counter == 0) {
            this.counter++;
            this.toast.presentToast("Press again to exit");
            setTimeout(() => { this.counter = 0 }, 3000)
          } else {
            this.platform.exitApp();
          }
        }
      }, 0);
    });    
  }
  checkDashboardComp(mod,type){
		
		if(this.perPipe.transform(this.permissions,mod,type)){
			
			return true
		}
		else{
			return false
		}
	}

  openPage(page) {
    
    if (this.nav.getActive().component != this.getPageForOpen(page.theme)) {
      this.menu.close();
      if(page.title == "LogOut"){
        this.loginProvider.logOut();
        this.nav.setRoot(HomePage);
      }else if(page.theme == "DashboardPage"){
        this.nav.setRoot(this.getPageForOpen(page.theme));
      }else if(page.theme == "TellAFriend"){
        this.socialSharing.share(`Please use the link below for downloading ${environment.dispAppName} app on your phone. ${environment.playStore}`).then(() => {
          if(environment.debug) console.log("tell a friend sharing done!");
        }).catch(() => {
          console.error("Error in tell a friend, sharing!");
          this.toast.presentToast("Unable to share!");
        });
      }else{
        if(this.nav.getActive().component == this.getPageForOpen("DashboardPage")){
          this.nav.push(this.getPageForOpen(page.theme));
        }else if(page.theme == "DashboardPage"){
          this.nav.setRoot(this.getPageForOpen(page.theme));  
        }else{
          this.nav.pop();
          this.nav.push(this.getPageForOpen(page.theme));            
        }
      }
    }else{
      this.menu.close();
    }
  }

  getPageForOpen(value: string): any {
    let selectPage: any;
    selectPage = {
      ComplaintTabsPage,
      VisitorTabsPage,
      DashboardPage,
      HomePage,
      NoticesPage,
      ProfilePage,
      BillingPaymentsPage,
      MeterPage,
      MySocietyPage,
      FeedbackPage,
      AboutUsPage,
      MyStaffTabsPage,
      SettingsPage,
      MembersPage,
      SurveyPage,
      FacilityPage,
      HowItWorksPage,
      MarketPlacePage,
      SingleMarketPlacePage,
      MarketplacecategoryPage,
      ExportMeterPage,
      ReferralPage,
      EventsPage,
    }
    return selectPage[value];
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts